import Vue from 'vue'
import Vuex from 'vuex'

import Auth from './modules/auth'

import AccountLogin from './modules/account/login'

import GlobalEvents from './modules/global_events'
import GlobParm from './modules/glob_parm'

import User from './modules/user'
import Gas from './modules/base_data/gas'
import Gastank from './modules/base_data/gas_tank'
import Depot from './modules/base_data/depot'
import Driver from './modules/base_data/driver'
import Car from './modules/base_data/car'
import CarIoCard from './modules/base_data/car_io_card'
import DriverIoCard from './modules/base_data/driver_io_card'

import Invoicing from './modules/dispatch/invoicing'
import InvoicingCheck from './modules/dispatch/invoicing_check/index'
import DistributionWriteoff from './modules/dispatch/distribution_writeoff/index'
import gasOrder from './modules/dispatch/gas_order'
import carSign from './modules/dispatch/car_sign'
import Distribution from './modules/dispatch/distribution'
import GasDemand from './modules/dispatch/gas_demand'
import gasRouterOrder from './modules/dispatch/gas_router_order'
import planOrderEdit from './modules/dispatch/plan_order_edit'

import AdjustOrder from './modules/dispatch/adjust_order'

import UpdateStatus from './modules/update_status'

import Pi from './modules/pi'

import mapSearchBlock from './modules/map/search_block'
import mapMap from './modules/map/map'

import outPageUrl from './modules/out_page'

import weiXinDistributionDetail from './modules/weixin/distribution_detail'
import weiXinGasHome from './modules/weixin/gas_home'
import weiXinInvoicingCheckProcess from './modules/weixin/invoicing_check_process/check_process'

import LossSystem from './modules/loss_system'

import mapCommon from './modules/map/common'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    Auth,
    AccountLogin,
    GlobalEvents,
    User,
    Gas,
    Gastank,
    GlobParm,
    Depot,
    Driver,
    Car,
    Invoicing,
    InvoicingCheck,
    DistributionWriteoff,
    gasOrder,
    carSign,
    AdjustOrder,
    Distribution,
    GasDemand,
    gasRouterOrder,
    planOrderEdit,
    CarIoCard,
    DriverIoCard,
    Pi,
    outPageUrl,
    mapSearchBlock,
    mapMap,
    UpdateStatus,
    weiXinDistributionDetail,
    weiXinInvoicingCheckProcess,
    weiXinGasHome,
    LossSystem,
    mapCommon
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js